import { CustomerWithReference } from 'generated-types/skills/customer_references';
import { Loader, Panel } from 'rsuite';

import { CustomerReference } from './skills/CustomerReference';

interface CustomerReferencesListProps {
    isLoading: boolean;
    filteredCustomerReferences: CustomerWithReference[];
    customerSearchWord: string;
    notesSearchWord: string;
    editAllowed: boolean;
}

const CustomerReferencesList = (props: CustomerReferencesListProps) => {
    const {
        isLoading,
        filteredCustomerReferences,
        customerSearchWord,
        notesSearchWord,
        editAllowed,
    } = props;
    if (isLoading) {
        return <Loader content={'Customer References are loading...'} />;
    }
    let message = '';
    if (
        filteredCustomerReferences.length === 0 &&
        customerSearchWord.trim() &&
        notesSearchWord.trim()
    ) {
        message = `No references found for "${customerSearchWord}" and "${notesSearchWord}"`;
    } else if (filteredCustomerReferences.length === 0 && customerSearchWord.trim()) {
        message = `No references found for "${customerSearchWord}"`;
    } else if (filteredCustomerReferences.length === 0 && notesSearchWord.trim()) {
        message = `No references found for "${notesSearchWord}"`;
    } else if (filteredCustomerReferences.length === 0) {
        message = 'No references added yet';
    }
    if (message) {
        return <p>{message}</p>;
    }

    return (
        <>
            {filteredCustomerReferences.length > 0 && (
                <Panel
                    bordered
                    style={{
                        marginBottom: 20,
                        paddingTop: 20,
                        maxWidth: 1200,
                        width: '100%',
                        background:
                            'linear-gradient(145deg, rgba(31,59,112,1) 0%, rgba(2,175,217,1) 50%, rgba(217,22,92,1) 100%)',
                    }}
                >
                    {(filteredCustomerReferences as CustomerWithReference[]).map(
                        (customerReference: CustomerWithReference) => (
                            <CustomerReference
                                key={`${customerReference.customer.circles_customer_id}-${customerReference.reference?.reference_uuid}`}
                                editAllowed={editAllowed}
                                customerWithReference={customerReference}
                                reference={customerReference.reference}
                            />
                        ),
                    )}
                </Panel>
            )}
        </>
    );
};

export default CustomerReferencesList;
